import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Static info layout used by About, Privacy, Terms, Cancellation pages.
 * Keep design language consistent with Profile section — no new patterns.
 */
export default function InfoPage({ title, subtitle, children, footer, testid = "info-page" }) {
    const navigate = useNavigate();
    return (
        <div className="min-h-screen bg-background">
            <div className="max-w-2xl mx-auto px-4 sm:px-6 py-6" data-testid={testid}>
                <button onClick={() => navigate(-1)} data-testid="info-back-btn"
                    className="inline-flex items-center gap-2 text-slate-400 hover:text-[#00FF66] text-xs font-bold uppercase tracking-widest">
                    <ArrowLeft className="w-4 h-4" /> Back
                </button>
                <h1 className="font-display text-3xl sm:text-4xl font-bold uppercase text-white mt-4">{title}</h1>
                {subtitle && <p className="text-slate-400 text-sm mt-2">{subtitle}</p>}
                <div className="mt-6 bg-slate-900 border border-slate-800 rounded-lg p-5 sm:p-7 text-slate-300 leading-relaxed">
                    {children}
                </div>
                <div className="mt-6 text-center">
                    <Link to="/profile" className="text-xs uppercase tracking-widest text-slate-500 hover:text-[#00FF66]">
                        Back to profile
                    </Link>
                </div>
                {footer && (
                    <div className="mt-8 pt-5 border-t border-slate-800/60">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    );
}
